import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { injectIntl } from 'react-intl'
import { Row, Col, Spin } from 'core/components/ui'
import SVG from 'core/components/svg'
import svg from 'assets/svg'
import { font } from 'assets/themes/theme-default'
import FilterTitle from '../title'

// USE Export for testing
export const StyledSVG = styled(SVG)`
  width: 75px;
  height: 30px;
  fill: ${props => props.theme.colors.color2.bg};
`

const FilterItemWrapper = styled(Col)`
  cursor: pointer;
  color: ${props => props.theme.colors.color2.bg};
  margin-bottom: 15px;
  font-size: ${font.size.sm};
  line-height: 18px;
  &.activ {
    color: ${props => props.theme.colors.color1.bg};
    ${StyledSVG} {
      fill: ${props => props.theme.colors.color1.bg};
    }
  }
`

/************* */

const FilterBody = props => {
  const { intl, loading, onChangeFilter, filters, filtersDatas } = props

  const { bodies } = filters
  const bodiesList = filtersDatas.bodies

  const handleClick = item => {
    let extendedBodiesValues = bodies ? [...bodies] : []
    const isSelected = extendedBodiesValues.filter(el => el === item.id).length > 0

    if (!isSelected) {
      extendedBodiesValues.push(item.id)
    } else {
      extendedBodiesValues = extendedBodiesValues.filter(el => el !== item.id)
    }

    const extendedFiltersValues = {
      ...filters,
      bodies: extendedBodiesValues
    }
    onChangeFilter(extendedFiltersValues)
  }

  const renderIcon = id => {
    let icon

    switch (id) {
      case '00010004':
        icon = svg.bodies.convertible
        break
      case '00010003':
        icon = svg.bodies.chopped
        break
      case 3:
        icon = svg.bodies.urban
        break
      case 4:
        icon = svg.bodies.compact
        break
      case '00010060':
        icon = svg.bodies.sedan
        break
      case '00010062':
        icon = svg.bodies.break
        break
      case 7:
        icon = svg.bodies.SUV
        break
      case '00010064':
        icon = svg.bodies.monospace
        break
      case 9:
        icon = svg.bodies.utility
        break
      default:
        break
    }

    return icon ? (
      <StyledSVG svg={icon} data-test="stock-vehicles-list-filters-body-FilterItemIcon" />
    ) : null
  }

  const renderItem = item => {
    const { wording, id } = item

    const isSelected = !bodies ? false : bodies.filter(el => el === id).length > 0

    return (
      <FilterItemWrapper
        key={wording}
        onClick={() => handleClick(item)}
        className={isSelected ? 'activ' : ''}
        span={8}
        data-test="stock-vehicles-list-filters-body-FilterItemWrapper"
      >
        <Row type="flex" style={{ flexDirection: 'column', alignItems: 'center' }}>
          <Col>{renderIcon(id)}</Col>
          <Col data-test="stock-vehicles-list-filters-body-FilterItemLabel">{wording}</Col>
        </Row>
      </FilterItemWrapper>
    )
  }

  return (
    <div data-test="component-stock-vehicles-list-filters-body">
      <FilterTitle
        label={intl.formatMessage({
          id: 'stock-vehicles-list-filters-body-title'
        })}
        data-test="stock-vehicles-list-filters-body-title"
      />
      <Row type="flex" justify={loading ? 'center' : 'start'}>
        {loading && <Spin />}
        {!loading && bodiesList && bodiesList.map(item => renderItem(item))}
      </Row>
    </div>
  )
}

FilterBody.propTypes = {
  filtersDatas: PropTypes.shape().isRequired,
  filters: PropTypes.shape().isRequired,
  onChangeFilter: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  intl: PropTypes.shape().isRequired
}

export default injectIntl(FilterBody)
